import React from 'react'
import { Text } from '@ui-kitten/components'
import { Controller } from 'react-hook-form'
import { View, StyleSheet } from 'react-native'
import PlatformDependantSelect from './PlatformDependantSelect'
import { useTranslation } from 'react-i18next'

export default function FormSelect({
  control,
  name,
  label,
  data,
  required = false,
  withSearch = false,
  style,
  renderRightAccessory,
  rightAccessory,
  labelAccessory,
  testID,
}) {
  const { t } = useTranslation()
  
  // Support backward compatibility while transitioning to new prop name
  const accessoryToUse = labelAccessory || rightAccessory || renderRightAccessory

  return (
    <>
      {label && (
        <View style={styles.labelContainer}>
          <Text category='label'>
            {label}
          </Text>
          {accessoryToUse?.()}
        </View>
      )}
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        render={({field: { onChange, value }, fieldState: { error }}) => (
          <>
            <PlatformDependantSelect
              data={data}
              selectedOption={value}
              onSelect={onChange}
              style={styles.field}
              withSearch={withSearch}
              testID={testID}
            />
            {error?.type === 'required' && (
              <Text status='danger' style={styles.errorText}>
                {t('fieldIsRequiredError')}
              </Text>
            )}
          </>
        )}
      />
    </>
  )
}

const styles = StyleSheet.create({
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 15,
    marginBottom: 5,
  },
  field: {
    marginBottom: 5
  },
  errorText: {
    marginTop: 5,
    marginBottom: 15
  }
}) 